export const LEAD_EMAIL = 'lussonovo@gmail.com'

const ENDPOINT = `https://formsubmit.co/ajax/${LEAD_EMAIL}`

interface SendLeadEmailArgs {
  subject: string
  fields: Record<string, string>
  files?: FileList | null
}

/**
 * Sends the lead + calculator estimate to the Lussonovo inbox.
 * Uses FormSubmit, so no backend is required: the first submission triggers a
 * one-time activation email to lussonovo@gmail.com that must be confirmed.
 */
export async function sendLeadEmail({ subject, fields, files }: SendLeadEmailArgs): Promise<void> {
  const body = new FormData()
  body.append('_subject', subject)
  body.append('_template', 'table')
  body.append('_captcha', 'false')

  Object.entries(fields).forEach(([key, value]) => body.append(key, value))

  if (files) {
    Array.from(files)
      .slice(0, 5)
      .forEach((file) => body.append('attachment', file, file.name))
  }

  const response = await fetch(ENDPOINT, {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body,
  })

  if (!response.ok) {
    throw new Error(`No se pudo enviar la solicitud (${response.status})`)
  }
}

export function formatMadridTimestamp(date: Date): string {
  return new Intl.DateTimeFormat('es-ES', {
    dateStyle: 'full',
    timeStyle: 'short',
    timeZone: 'Europe/Madrid',
  }).format(date)
}
